import { shallowEqual, useSelector } from "react-redux"

export const useGetGroupName = () => {
    const isRenameGroupsStore = useSelector(
        (store) => store.settings.isRenameGroups === '1'
    )
    const groupNames = useSelector((store) => (
        {
            groupNameSingularStore: store.settings.custom.groupNameSingular,
            groupNamePluralStore: store.settings.custom.groupNamePlural,
            groupNameGenitiveStore: store.settings.custom.groupNameGenitive,
            groupNameAccusativeStore: store.settings.custom.groupNameAccusative,
        }
    ), shallowEqual)

    return(
        {
            groupNameSingular: (isRenameGroupsStore && !!groupNames?.groupNameSingularStore?.trim()) ?
                groupNames?.groupNameSingularStore : 'Группа',
            groupNamePlural: (isRenameGroupsStore && !!groupNames?.groupNamePluralStore?.trim()) ?
                groupNames?.groupNamePluralStore : 'Группы',
            groupNameGenitive: (isRenameGroupsStore && !!groupNames?.groupNameGenitiveStore?.trim()) ?
                groupNames?.groupNameGenitiveStore : 'Групп',
            groupNameAccusative: (isRenameGroupsStore && !!groupNames?.groupNameAccusativeStore?.trim()) ?
                groupNames?.groupNameAccusativeStore : 'Группу',
        }
    )
}
